module.exports = `${require.publicPath}icon15.b1849c2b.png`;